import { useState } from 'react';
import { Modal } from '@rabbit/elements/shared-components';
import { useLocation } from 'react-router-dom';
import { VendableEditorProviderWrapper } from '@rabbit/bizproc/react';
import VendableDetailsTemplate from '../components/templates/VendableDetailsTemplate/VendableDetailsTemplate';
import { useTranslation } from 'react-i18next';
import { ModalAddEditVendableV2 } from '../components/organisms/ModalNewEditProduct/ModalTypes/ModalAddEditVendable.v2';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface VendableDetailsViewProps {}

export function VendableDetailsView(props: VendableDetailsViewProps) {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const vendableId = location.pathname.split('/')[2];
  const [isEditProductModalOpen, setIsEditProductModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <VendableEditorProviderWrapper>
      <VendableDetailsTemplate
        vendableId={vendableId}
        setIsEditProductModalOpen={setIsEditProductModalOpen}
      />
      {isEditProductModalOpen && (
        <Modal
          kind={'generic'}
          className="md:w-3/4 lg:w-2/4"
          settings={{
            handleClose: () => setIsEditProductModalOpen(false),
            title: t('general.editProduct'),
            loading: loading,
          }}
        >
          <ModalAddEditVendableV2
            handleClose={() => setIsEditProductModalOpen(false)}
            vendableId={vendableId}
            setLoading={setLoading}
          />
        </Modal>
      )}
    </VendableEditorProviderWrapper>
  );
}

export default VendableDetailsView;
